import { render, staticRenderFns } from "./ReviewReminder.vue?vue&type=template&id=5805744e&scoped=true&"
import script from "./ReviewReminder.vue?vue&type=script&lang=js&"
export * from "./ReviewReminder.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReminder.vue?vue&type=style&index=0&id=5805744e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805744e",
  null
  
)

export default component.exports